var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M26.6668 14.6666H10.4402L17.8935 7.21325L16.0002 5.33325L5.3335 15.9999L16.0002 26.6666L17.8802 24.7866L10.4402 17.3333H26.6668V14.6666Z"}})}
var staticRenderFns = []

export { render, staticRenderFns }